import PantallaGameGeneratorSeleccionarFlashcards from './pantalla-game-generator-seleccionar-flashcards'
export default PantallaGameGeneratorSeleccionarFlashcards